import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateAccountingPeriodStatus } from './accountingPeriod';
import type {
  AccountingPeriod,
  UpdateAccountingPeriodStatusRequest,
} from './accountingPeriod.types';
import {
  ACCOUNTING_PERIOD_METADATA_KEY,
  ACCOUNTING_PERIODS_KEY,
} from './constants';

export const useUpdateAccountingPeriodStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: number;
      data: UpdateAccountingPeriodStatusRequest;
    }) => updateAccountingPeriodStatus(id, data),
    onSuccess: (_updatedPeriod: AccountingPeriod) => {
      // Invalidate and refetch all accounting periods queries
      queryClient.invalidateQueries({ queryKey: [ACCOUNTING_PERIODS_KEY] });
      // Also invalidate metadata since status changes might affect counts
      queryClient.invalidateQueries({
        queryKey: [ACCOUNTING_PERIOD_METADATA_KEY],
      });
    },
  });
};
